import sso from '@/api/sso'
import authority from '@/api/authority'

// initial state
const state = {
    email: null,
    password: 'password',
    userCode: null,
    isAuthenticated: true,

}

// getters
const getters = {}

// actions
const actions = {
    applyForAuthCode({}, request) {
        sso.applyForAuthCode(response => {
            request.callback(response.authUrl)
        }, request)
    },
    applyForToken({}, request) {

        sso.applyForToken(response => {
            console.log(44444, response)

            //模拟登录
            if (response.message === 'success') {
                authority.setAccessToken(response.accessToken)
                authority.setToken(response.token)
                authority.setusername(response.jwtUser.userCode)

                authority.setRoles(response.jwtUser.roles)
                authority.setUserCode(response.jwtUser.userCode)
                request.callback()
            }
        }, request.code)
    },
    ssoLogin({}, request) {
        sso.oauth2Login(response => {
            request.callback(response.loginUrl)
        }, request)
    },
    redirectLoginUrl({}, request) {
        sso.goToOauthLogin(response => {
            request.callback(response.loginUrl)
        })
    }
}

// mutations
const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}